import type { GridApi } from 'ag-grid-community';
import { useCallback } from 'react';
import type { Category } from 'shared/middlewares/analytics/logger';
import { logAnalytics } from 'shared/middlewares/analytics/logger';

export const useResetColumns = (gridApi?: GridApi | null, blotterName?: Category) => {
  return useCallback(() => {
    gridApi?.applyColumnState({
      defaultState: { sort: null },
    });
    gridApi?.setFilterModel(null);
    gridApi?.onFilterChanged('advancedFilter');
    if (blotterName) {
      logAnalytics.trackEvent(blotterName, 'Clear all filters');
    }
  }, [gridApi, blotterName]);
};
